import React from 'react'

const Loading = () => {
  return (
    <div className='maining'>
    <div className='loading'>
   <div className='stroke1'></div>
   <div className='stroke2'></div>
   <div className='stroke1'></div>
   <div className='stroke2'></div>
 </div>
 <h2>Stay Jiggy...</h2>
 </div>
  )
}

export default Loading